/*!

*/
import React , {useEffect, useState}from "react";
// react plugin used to create charts
import ReactTable from "components/ReactTable/ReactTablebep.js";
// reactstrap components
import { faker } from '@faker-js/faker';
import {
  Badge, 
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);


import "react-datepicker/dist/react-datepicker.css";
import Spin from '../../assets/img/Spinner2.gif'
import Select from "react-select";
import {customStyles} from '../../helpers/mycomps'
import { useSelector , useDispatch} from 'react-redux'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';


const months = [
  {value : 0, label : "Jan"},
  {value : 1, label : "Feb"},
  {value : 2, label : "Mar"},
  {value : 3, label : "April"},
  {value : 4, label : "May"},
  {value : 5, label : "June"},
  {value : 6, label : "July"},
  {value : 7, label : "Aug"},
  {value : 8, label : "Sept"},
  {value : 9, label : "Oct"},
  {value : 10, label : "Nov"},
  {value : 11, label : "Dec"}
]

const cats = [
   {value : 1 , categoryCode : "1" , label : "Cars"},
   {value : 3 , categoryCode : "2" , label : "Yachts"}, 
   {value : 2 , categoryCode : "3" , label : "Machines"}
]

function Dashboard(props) {

  const userinfo = useSelector(state => state.profileStore.profileData)

  let d = new Date()
  d.setDate(d.getDate() - 7);

  const [showProcessing , setShowProcessing] = useState(false)
  const [month , setMonth] = useState({value : d.getMonth() , label : d.toLocaleString('default', { month: 'short' })})
  const [cat , setCat] = useState({value : "1" , label : "Cars" })
  
  const [limit, setLimit] = useState(10)
  const [total, setTotal] = useState(1)
  const [pageNumber, setPageNumber] = useState(0) 

  const [dbdata, setDbdata] = useState({
    totallisting : "0",
    countp  : "0",
    countf  : "0",
    countd : "0",
    countclickstotal : "0",
    countclicksdetails : "0",
    countclicksenquiry : "0",
    countclickswa : "0",
    countclickscall : "0"

  })

  const [dbdatadet, setDbdatadet] = useState([])

  const [labels , setLables] = useState(['1', '2', '3', '4', '5', '6', '7', '8','9','10', '11', '12', '13', '14', '15', '16', '17', '18','19','20' ,'21', '22', '23', '24', '25', '26', '27', '28','29','30', '31' ])
  const [countsx, setCountsx] = useState(["0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0"])

  const SpinnerNew = <div className="spoverlay"><center><img style={{marginTop : 200}} src={Spin} alt="a" width={"200px"}/><h4>Please wait...</h4></center></div>

  
    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: `${cat.label} clicks`,
        },
      },
    };


  useEffect(() => {
    try{
      if(userinfo[0].tuid !== "" || userinfo[0].tuid !==undefined){
        getstats()
        getcdets(0)
        getchart()
      }
      
    }catch(e){

    }
    
  }, [userinfo, month, cat])

  const errorhandler = (error) => {
    try{
      if(error.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
      }else{
        props.swal(error.response.data.message)
      }
    } catch(e){
      props.swal("error processing request at this time, please contact support.")
    } 
  
  }

  const getstats = () => {
    
    props.API.get(`/ten/dblc/${userinfo[0].tuid}/${month.value}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
     setDbdata({ 
      totallisting : res.data.totallisting,
      countp : res.data.countp, 
      countf  : res.data.countf,
      countd : res.data.countd,
      countclickstotal : res.data.countclickstotal,
      countclicksdetails : res.data.countclicksdetails,
      countclicksenquiry : res.data.countclicksenquiry,
      countclickswa : res.data.countclickswa ,
      countclickscall : res.data.countclickscall
     })

    }).catch(function (error) {
      console.log(error)
      setShowProcessing(false)
     errorhandler(error)       
    }) 
    setShowProcessing(false)
  }

  const getcdets = (skipy) => {
    props.API.get(`/ten/dblcclicks/${skipy}/${limit}/${userinfo[0].tuid}/3/${month.value}/`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
      setDbdatadet(res.data.data)
      setTotal(res.data.total)
      
     }).catch(function (error) {
       console.log(error)
       setShowProcessing(false)
       
       if(error.response.status === 401){
         props.swal("Unauthorized, please login again.").then(t => {
             props.history.push(`/auth/login`)
         })   
       }       
     }) 
     setShowProcessing(false)
  }

  const getchart = () => {
    props.API.get(`/ten/dblccat/${userinfo[0].tuid}/${month.value}/${cat.value}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
      //setDbdatadet(res.data.data)
      if(res.data.data.length >= 1){
          setLables(res.data.data.map(x => x._id))
          setCountsx(res.data.data.map(x => x.count))   
      }
      else{
  
        setLables(['1', '2', '3', '4', '5', '6', '7', '8','9','10', '11', '12', '13', '14', '15', '16', '17', '18','19','20' ,'21', '22', '23', '24', '25', '26', '27', '28','29','30' ])
        setCountsx(["0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0"])
              
      }      
     }).catch(function (error) {
       console.log(error)
       setShowProcessing(false)
       errorhandler(error)  
     }) 
     setShowProcessing(false)
  }

  const nextpage = () => {
    let page = pageNumber === 0 ?  1  : pageNumber;
    if(Math.ceil(total/limit) >= pageNumber + 1){
        
        setPageNumber(pageNumber + 1)
        page = pageNumber + 1 
    }else{
        
        page = pageNumber
        
    }
    let npage = page -1 
    let tskip = pageNumber === 0 ?  0 : npage  * limit        
    
    getcdets(tskip)
    
    
  }

  const previouspage = () => { 
    let page = pageNumber === 0 ?  0  : pageNumber -1 ;
    if(page <= 0){
        
        setPageNumber(0)
        getcdets(0)
    }else{
        
        page = pageNumber -1 
        let tskip = page  * limit      
        setPageNumber(page)  
        getcdets(tskip)
    }
    
    
    //console.log(total)    
      

  }

  return (
    <>
      {showProcessing && Spin } 
      <div className="content">
        <Row>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-globe text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p style={{fontSize : "0.6rem"}} className="card-category">Enquiry / WA / Calls</p>
                      <CardTitle style={{fontSize : "0.9rem"}} tag="p">{Number(dbdata?.countclicksenquiry)} /  {Number(dbdata?.countclickswa)} / {Number(dbdata?.countclickscall)}  </CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-refresh" onClick={h => getstats()} />
                  Total Enquiry for the month {month.label}
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-money-coins text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category" style={{fontSize : "0.6rem"}}>Details</p>
                      <CardTitle tag="p" style={{fontSize : "0.9rem"}}>{dbdata.countclicksdetails}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-calendar-o" onClick={h => getstats()} />
                  Details clicked for the month {month.label}
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-vector text-danger" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Premium / Featured / Delisted</p>
                      <CardTitle tag="p" >{dbdata.countp} / {dbdata.countf} /{dbdata.countd}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-clock-o" onClick={h => getstats()}/>
                  Listing by type 
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-favourite-28 text-primary" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">My List</p>
                      <CardTitle tag="p" style={{fontSize : "0.9rem"}}>{dbdata.totallisting}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fa fa-refresh" onClick={h => getstats()}/>
                  Total Listings 
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
       

        <Row>
          <Col lg="6" sm="12">
            <Card>
              <CardBody>
              <ReactTable 
                           data= {dbdatadet}
                           nextpage = {nextpage}
                           totalpages = {Math.floor(Number(total)/Number(limit))}
                           pagenumber = {pageNumber}
                           pagesize = {limit}
                           previouspage={previouspage}
                           pageNumber = {pageNumber}
                           setPageNumber={setPageNumber}
                           setLimit={setLimit}
                           limit={limit}
                           columns={[
                            {
                                Header: "DateTime",
                                accessor: d =>  <span>{new Date(d.cDate).toDateString()}</span>,
                                maxWidth : -20
                            }, 
                           
                             {
                               Header: "Listing ID",
                               accessor: d =>  d.tluid ,
                            
                            },
                            
                             {
                               Header: "Action",
                               accessor: d => d.cid === "3" ? "Enquiry" : d.cid === "1" ? "Whatsapp" : "Details",
                             },
                             {
                                 Header: "Email",
                                 accessor: d =>  d.uid,
                                
                               },
                             
                           ]}
                           /*
                               You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                             */
                           className="-striped -highlight primary-pagination"
                         />
              </CardBody>
     
            </Card>
          </Col>
    
          <Col lg="6" sm="12">
          <Card>
              <CardHeader>
                <Row>
                  <Col sm="2">
                    <div className="numbers pull-left">{Number(dbdata.countclicksenquiry) + Number(dbdata.countclickswa) + Number(dbdata.countclicksdetails) + Number()}</div>
                  </Col>
                  <Col>
                      <Row style={{marginBottom : 15, marginTop : -5}}>
                        <Col></Col>
                        <Col > 
                              <Select options={cats} styles={customStyles} className={"shadow"}
                                      onChange={e=> {setCat(e)}} value={cat}  />
                        </Col>
                        <Col > <Select options={months} styles={customStyles} className={"shadow"}
                                      onChange={e=> {setMonth(e)}} value={month}  />
                              
                        </Col>
                        <Col></Col>
                      </Row>
                  </Col>
                  <Col sm="2">
                    <div className="pull-right" style={{marginTop : -30}}>
                      <h4><Badge color="success" pill>
                        {month.label}
                      </Badge>
                      </h4>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Line options={options} data={
                  {
                    labels,
                    datasets: [
                      {
                        label: cat.label,
                        data: countsx,
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132, 0.5)',
                      },
                     
                    ],
                  }
                } />;
              </CardBody>
              <CardFooter>
                <hr />
               
              </CardFooter>
            </Card>
          </Col>
        </Row>
     
      
      </div>
    </>
  );
}

export default Dashboard;
